import { UpdateCompanyProps } from '@commenda/types/src/company/types';
import { fetcher } from '@commenda/utils';

export default async function updateCompany({
  nextAuthToken,
  companyId,
  data,
}: {
  companyId: number;
  nextAuthToken?: string;
  data: UpdateCompanyProps;
}): Promise<boolean> {
  const res = await fetcher(
    `company/${companyId}`,
    {
      method: 'POST',
      body: data,
    },
    nextAuthToken
  );

  return res.ok;
}
